/*
 * 维护单组件公共 UI 控件（无第三方依赖）
 * field / panel / switch / radio / input / textarea / select / tagSelect / upload / rtable
 * tag / text / link / toast / modal(alert, confirm) / loading / preview
 */
export default function installUi(MW) {
  var w = window;
  var h = MW.h;
  var util = MW.util;
  var ui = (MW.ui = {});

  /* ---------- 布局 ---------- */
  ui.panel = function (o) {
    var body = [].slice.call(arguments, 1);
    return h(
      "section",
      { class: ["mw-panel", o.cls], id: o.id || null, dataset: o.anchor ? { anchor: o.anchor } : null },
      (o.title || o.extra) &&
        h(
          "div",
          { class: "mw-panel__head" },
          h(
            "div",
            { class: "mw-panel__title" },
            o.icon && h("i", { class: o.icon }),
            h("h2", null, o.title),
            o.sub && h("small", null, o.sub),
            o.badge
          ),
          o.extra && h("div", { class: "mw-panel__extra" }, o.extra)
        ),
      h("div", { class: "mw-panel__body" }, body)
    );
  };

  ui.grid = function (cols, children, cls) {
    return h("div", { class: ["mw-grid", "mw-grid--" + cols, cls] }, children);
  };

  ui.field = function (o) {
    var children = [].slice.call(arguments, 1);
    return h(
      "div",
      {
        class: [
          "mw-field",
          o.inline && "mw-field--inline",
          o.error && "has-error",
          o.span && "span-" + o.span,
          o.disabled && "is-disabled",
          o.cls,
        ],
        dataset: o.key ? { key: o.key } : null,
      },
      o.label &&
        h(
          "div",
          { class: "mw-field__label" },
          o.required && h("i", { class: "mw-req" }, "*"),
          h("span", null, o.label),
          o.labelExtra
        ),
      h("div", { class: "mw-field__ctrl" }, children),
      o.desc && h("div", { class: ["mw-field__desc", o.descWarn && "is-warn"] }, o.desc),
      o.error && h("div", { class: "mw-field__error" }, h("i", { class: "ri-error-warning-fill" }), o.error)
    );
  };

  /* ---------- 展示 ---------- */
  ui.text = function (v, o) {
    o = o || {};
    var empty = util.isEmpty(v);
    return h(
      "div",
      { class: ["mw-text", o.danger && "is-danger", o.ok && "is-ok", empty && "is-empty", o.pre && "is-pre", o.cls] },
      empty ? o.placeholder || "—" : String(v)
    );
  };

  ui.tag = function (text, type, icon) {
    return h("span", { class: ["mw-tag", "mw-tag--" + (type || "info")] }, icon && h("i", { class: icon }), text);
  };

  ui.link = function (href, text, o) {
    o = o || {};
    if (!href) return ui.text("");
    return h(
      "a",
      { class: "mw-link", href: href, target: "_blank", rel: "noopener", title: href },
      h("i", { class: o.icon || "ri-external-link-line" }),
      h("span", null, text || href)
    );
  };

  /* ---------- 表单控件 ---------- */
  ui.switch = function (o) {
    return h(
      "button",
      {
        type: "button",
        role: "switch",
        "aria-checked": String(!!o.value),
        class: ["mw-switch", o.value && "is-on", o.disabled && "is-disabled", o.loading && "is-loading", o.size && "mw-switch--" + o.size],
        disabled: !!(o.disabled || o.loading),
        onClick: function () {
          o.onChange && o.onChange(!o.value);
        },
      },
      h("span", { class: "mw-switch__dot" }, o.loading && h("i", { class: "ri-loader-4-line mw-spin" })),
      o.text && h("span", { class: "mw-switch__txt" }, o.value ? o.text[0] : o.text[1])
    );
  };

  var TONE = { 正常: "ok", 匹配: "ok", 已更换: "ok", 异常: "danger", 不匹配: "danger", 不适用: "muted", 未更换: "muted" };
  ui.radio = function (o) {
    return h(
      "div",
      { class: ["mw-radio", o.disabled && "is-disabled", o.block && "mw-radio--block"], role: "radiogroup" },
      o.options.map(function (op) {
        var v = op && op.value !== undefined ? op.value : op;
        var label = op && op.label !== undefined ? op.label : op;
        var on = o.value === v;
        return h(
          "button",
          {
            type: "button",
            role: "radio",
            "aria-checked": String(on),
            class: ["mw-radio__item", on && "is-on", "tone-" + (TONE[v] || "primary")],
            disabled: !!o.disabled,
            onClick: function () {
              if (!on && o.onChange) o.onChange(v);
            },
          },
          on && h("i", { class: TONE[v] === "danger" ? "ri-error-warning-fill" : "ri-checkbox-circle-fill" }),
          label
        );
      })
    );
  };

  ui.input = function (o) {
    return h("input", {
      class: ["mw-input", o.cls],
      name: o.name || null,
      type: o.type || "text",
      inputmode: o.inputmode || null,
      value: o.value == null ? "" : o.value,
      placeholder: o.placeholder || "请输入",
      disabled: !!o.disabled,
      onInput: function (e) {
        o.onInput && o.onInput(e.target.value);
      },
      onBlur: function (e) {
        o.onBlur && o.onBlur(e.target.value);
      },
    });
  };

  ui.textarea = function (o) {
    var el = h("textarea", {
      class: ["mw-input", "mw-textarea", o.cls],
      name: o.name || null,
      rows: o.rows || 3,
      placeholder: o.placeholder || "请输入",
      disabled: !!o.disabled,
      maxlength: o.maxlength || null,
      onInput: function (e) {
        o.onInput && o.onInput(e.target.value);
        if (counter) counter.textContent = e.target.value.length + (o.maxlength ? " / " + o.maxlength : "");
      },
      onBlur: function (e) {
        o.onBlur && o.onBlur(e.target.value);
      },
    });
    el.value = o.value == null ? "" : o.value;
    var counter = o.counter ? h("span", { class: "mw-textarea__count" }, el.value.length + (o.maxlength ? " / " + o.maxlength : "")) : null;
    return counter ? h("div", { class: "mw-textarea__wrap" }, el, counter) : el;
  };

  ui.select = function (o) {
    var el = h(
      "select",
      {
        class: ["mw-input", "mw-select", util.isEmpty(o.value) && "is-placeholder"],
        disabled: !!o.disabled,
        onChange: function (e) {
          el.classList.toggle("is-placeholder", !e.target.value);
          o.onChange && o.onChange(e.target.value);
        },
      },
      h("option", { value: "" }, o.placeholder || "请选择"),
      (o.options || []).map(function (op) {
        var v = op && op.value !== undefined ? op.value : op;
        return h("option", { value: v }, op && op.label !== undefined ? op.label : op);
      })
    );
    el.value = o.value == null ? "" : o.value;
    return el;
  };

  /**
   * 多选 + 可新建（对应原 Select multiple allowCreate filterable）；内部自渲染，不依赖外部重绘
   * PC：下拉层挂到 body 上按输入框位置定位（不被后面的检查项遮挡），下方空间不足时自动向上展开；支持 ↑↓ 回车
   * 手机：底部弹出选择面板，不自动弹输入法；搜索框在面板顶部，输入法弹出时面板整体抬到键盘上方
   * o: value, options, disabled, placeholder, title(手机面板标题), onChange(list), onBlur(list)
   */
  ui.tagSelect = function (o) {
    var value = (o.value || []).slice();
    var wrap = h("div", { class: ["mw-tagselect", o.disabled && "is-disabled"] });
    var box = null, input = null;
    var open = false, mobile = false;
    var pop = null, list = null, panel = null, kwInput = null, chipsEl = null, cntEl = null, clearEl = null;
    var items = [], active = -1, unbind = [], raf = 0, baseH = 0;

    function opts() {
      var seen = {};
      return (o.options || []).filter(function (x) {
        if (seen[x]) return false;
        seen[x] = 1;
        return true;
      });
    }
    function on(target, type, fn, opt) {
      target.addEventListener(type, fn, opt);
      unbind.push(function () { target.removeEventListener(type, fn, opt); });
    }
    function kwEl() { return mobile ? kwInput : input; }
    function kw() { var el = kwEl(); return el ? el.value.trim() : ""; }
    function setKw(t) { var el = kwEl(); if (el) el.value = t; }
    function chip(v, i) {
      return h("span", { class: "mw-chip" }, v,
        !o.disabled && h("i", { class: "ri-close-line", onClick: function (e) {
          e.stopPropagation();
          var n = value.slice();
          n.splice(i, 1);
          commit(n);
        } }));
    }
    function commit(next) {
      value = next;
      o.onChange && o.onChange(value.slice());
      paintBox();
      if (open) { paintMenu(); place(); }
    }
    function toggle(x) {
      var had = kw();
      setKw("");
      if (mobile && had && kwInput) kwInput.blur();
      commit(value.indexOf(x) > -1 ? value.filter(function (y) { return y !== x; }) : value.concat(x));
    }
    function create(t) {
      t = String(t || "").trim();
      if (!t) return;
      setKw("");
      if (mobile && kwInput) kwInput.blur();
      if (value.indexOf(t) < 0) commit(value.concat(t));
      else if (open) paintMenu();
    }

    /* ---------- 输入框本体 ---------- */
    function paintBox() {
      var keep = input ? input.value : "";
      var asSheet = util.isMobileView();
      wrap.innerHTML = "";
      wrap.classList.toggle("is-open", open);
      var kids = value.map(chip);
      if (asSheet) {
        input = null;
        if (!value.length) kids.push(h("span", { class: "mw-tagselect__ph" }, o.placeholder || "请选择"));
      } else {
        kids.push(input = h("input", {
          class: "mw-tagselect__input",
          placeholder: value.length ? "" : o.placeholder || "请选择或输入后回车",
          disabled: !!o.disabled,
          value: keep,
          onInput: function () { active = -1; paintMenu(); place(); },
          onKeydown: onKey,
        }));
      }
      kids.push(h("i", { class: "ri-arrow-down-s-line mw-tagselect__arrow" }));
      box = h("div", { class: "mw-tagselect__box", onClick: function () {
        if (o.disabled) return;
        if (!open) (util.isMobileView() ? openSheet : openPop)();
        else if (input) input.focus();
      } }, kids);
      wrap.appendChild(box);
      if (open && !mobile && input) setTimeout(function () { if (input && open) input.focus(); }, 0);
    }
    function onKey(e) {
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        if (!open) return;
        e.preventDefault();
        if (!items.length) return;
        active = (active + (e.key === "ArrowDown" ? 1 : -1) + items.length) % items.length;
        markActive();
      } else if (e.key === "Enter") {
        e.preventDefault();
        if (open && active > -1 && items[active]) items[active].act();
        else create(input.value);
      } else if (e.key === "Backspace" && !input.value && value.length) {
        commit(value.slice(0, -1));
      } else if (e.key === "Escape" || e.key === "Tab") close();
    }
    function markActive() {
      items.forEach(function (it, i) { it.el.classList.toggle("is-active", i === active); });
      var it = items[active];
      if (it && it.el.scrollIntoView) it.el.scrollIntoView({ block: "nearest" });
    }

    /* ---------- 选项列表（PC 下拉层 / 手机面板共用） ---------- */
    function paintMenu() {
      if (!list) return;
      var k = kw();
      var all = opts();
      var shown = all.filter(function (x) { return !k || String(x).indexOf(k) > -1; });
      list.innerHTML = "";
      items = [];
      function add(el, act) {
        if (mobile) el.addEventListener("click", act);
        else el.addEventListener("mousedown", function (e) { e.preventDefault(); act(); });
        items.push({ el: el, act: act });
        list.appendChild(el);
      }
      if (k && all.indexOf(k) < 0 && value.indexOf(k) < 0) {
        add(h("div", { class: "mw-tagselect__opt is-create" }, h("i", { class: "ri-add-line" }), h("span", null, "新建「" + k + "」")),
          function () { create(k); });
      }
      shown.forEach(function (x) {
        var sel = value.indexOf(x) > -1;
        add(h("div", { class: ["mw-tagselect__opt", sel && "is-on"] },
          h("span", null, x),
          mobile ? h("i", { class: sel ? "ri-checkbox-circle-fill mw-tagselect__tick" : "mw-tagselect__tick is-off" })
                 : sel && h("i", { class: "ri-check-line" })),
          function () { toggle(x); });
      });
      if (!items.length) {
        list.appendChild(h("div", { class: "mw-tagselect__empty" },
          all.length ? "无匹配项" : "暂无可选项", mobile ? "，可在上方输入后新建" : "，输入后回车可新建"));
      }
      if (active >= items.length) active = -1;
      if (!mobile) markActive();
      if (mobile) {
        cntEl.textContent = value.length ? "已选 " + value.length + " 项" : "未选择";
        cntEl.classList.toggle("is-on", value.length > 0);
        chipsEl.innerHTML = "";
        value.forEach(function (v, i) { chipsEl.appendChild(chip(v, i)); });
        clearEl.style.display = k ? "" : "none";
      }
    }

    /* ---------- PC：挂在 body 上的下拉层 ---------- */
    function openPop() {
      open = true;
      mobile = false;
      active = -1;
      pop = list = MW.addFloating(h("div", { class: "mw-tagselect__pop" }));
      on(document, "mousedown", function (e) {
        if (!wrap.contains(e.target) && !pop.contains(e.target)) close();
      }, true);
      on(window, "resize", schedule);
      on(window, "scroll", function (e) { if (!pop || !pop.contains(e.target)) schedule(); }, true);
      paintBox();
      paintMenu();
      place();
    }
    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; place(); });
    }
    function place() {
      if (!open || mobile || !pop) return;
      if (!document.body.contains(wrap)) return close();
      var r = box.getBoundingClientRect();
      var vh = window.innerHeight, vw = window.innerWidth, gap = 6, margin = 10;
      if (r.bottom < 0 || r.top > vh) return close();
      var below = vh - r.bottom - gap - margin, above = r.top - gap - margin;
      pop.style.maxHeight = "none";
      var need = Math.min(300, pop.scrollHeight);
      var up = below < need && above > below;
      var maxH = Math.max(96, Math.min(300, up ? above : below));
      var width = Math.max(r.width, 220);
      pop.style.width = width + "px";
      pop.style.left = Math.max(margin, Math.min(r.left, vw - width - margin)) + "px";
      pop.style.maxHeight = maxH + "px";
      if (up) { pop.style.top = "auto"; pop.style.bottom = vh - r.top + gap + "px"; }
      else { pop.style.bottom = "auto"; pop.style.top = r.bottom + gap + "px"; }
      pop.classList.toggle("is-up", up);
    }

    /* ---------- 手机：底部选择面板 ---------- */
    function openSheet() {
      open = true;
      mobile = true;
      var vv = window.visualViewport;
      baseH = vv ? vv.height : window.innerHeight;
      kwInput = h("input", {
        type: "search", class: "mw-tsheet__input", placeholder: "搜索，或输入新内容后点“新建”",
        enterkeyhint: "done", autocomplete: "off",
        onInput: function () { paintMenu(); },
        onKeydown: function (e) {
          if (e.key === "Enter") { e.preventDefault(); if (kw()) create(kw()); else kwInput.blur(); }
        },
      });
      clearEl = h("button", { type: "button", class: "mw-tsheet__clear", "aria-label": "清空搜索",
        onClick: function () { setKw(""); paintMenu(); kwInput.focus(); } }, h("i", { class: "ri-close-circle-fill" }));
      cntEl = h("span", { class: "mw-tsheet__cnt" });
      chipsEl = h("div", { class: "mw-tsheet__chips" });
      list = h("div", { class: "mw-tsheet__list" });
      panel = h("div", { class: "mw-tsheet__panel" },
        h("div", { class: "mw-tsheet__grab" }),
        h("div", { class: "mw-tsheet__head" },
          h("b", null, o.title || "请选择"), cntEl,
          h("button", { type: "button", class: "mw-tsheet__x", "aria-label": "关闭", onClick: close }, h("i", { class: "ri-close-line" }))),
        h("label", { class: "mw-tsheet__search" }, h("i", { class: "ri-search-line" }), kwInput, clearEl),
        chipsEl,
        list,
        h("div", { class: "mw-tsheet__foot" },
          h("button", { type: "button", class: "mw-btn mw-btn--primary mw-btn--block", onClick: close }, "完成")));
      pop = MW.addFloating(h("div", { class: "mw-tsheet", onClick: function (e) { if (e.target === pop) close(); } }, panel));
      // iOS 上 body overflow:hidden 挡不住背景滚动：面板列表以外的区域禁止拖动
      on(pop, "touchmove", function (e) { if (!list.contains(e.target) && !chipsEl.contains(e.target)) e.preventDefault(); }, { passive: false });
      document.body.classList.add("mw-noscroll");
      if (vv) { on(vv, "resize", fitKeyboard); on(vv, "scroll", fitKeyboard); }
      paintBox();
      paintMenu();
      fitKeyboard();
    }
    /** 输入法弹出时把面板抬到键盘上方，并压缩高度，保证顶部搜索框始终可见 */
    function fitKeyboard() {
      if (!panel) return;
      var vv = window.visualViewport;
      if (!vv) return;
      var kb = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
      var kbOpen = kb > 80 || vv.height < baseH - 120;
      panel.style.bottom = kb + "px";
      panel.style.maxHeight = Math.round(kbOpen ? vv.height - 12 : Math.min(vv.height, baseH) * 0.8) + "px";
      pop.classList.toggle("is-kb", kbOpen);
    }

    function close() {
      if (!open) return;
      open = false;
      unbind.forEach(function (fn) { fn(); });
      unbind = [];
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
      if (pop) {
        pop.remove();
        var i = MW.floating.indexOf(pop);
        if (i > -1) MW.floating.splice(i, 1);
      }
      if (mobile && !document.querySelector(".mw-mask")) document.body.classList.remove("mw-noscroll");
      pop = list = panel = kwInput = chipsEl = cntEl = clearEl = null;
      items = [];
      active = -1;
      if (input) input.value = "";
      mobile = false;
      paintBox();
      o.onBlur && o.onBlur(value.slice());
    }

    paintBox();
    return wrap;
  };

  /**
   * 上传（对应平台 Upload，值结构与平台一致：[{name, uid, status, url, response:{FileList:[{name,url}]}}]）
   * o: value, maxCount, accept, capture(user|environment), disabled, text, onChange(list), card(图片卡片模式)
   *    icon 按钮图标；hint 按钮下方的操作引导；hero=true 时空列表显示为整行大按钮（人脸拍照等关键操作）
   */
  ui.upload = function (o) {
    var list = Array.isArray(o.value) ? o.value : [];
    var max = o.maxCount || 1;
    var busy = false;
    var wrap = h("div", { class: ["mw-upload", o.disabled && "is-disabled", o.card === false && "mw-upload--file"] });
    function paint() {
      wrap.innerHTML = "";
      list.forEach(function (f, i) {
        var pend = util.isPendingFile(f);
        var up = pend && MW.sync && MW.sync.uploaded ? MW.sync.uploaded(f._local) : null;
        if (up) { f = up; pend = false; }
        var url = pend ? MW.files.thumb(f._local, function () { paint(); }) : util.fileUrl(f);
        var img = pend ? !!url : util.isImage(f);
        wrap.appendChild(
          h(
            "div",
            { class: ["mw-upload__item", pend && "is-pending"], title: pend ? "没网时拍摄，联网后自动上传" : f.name || "" },
            img
              ? h("img", { src: url, alt: f.name || "", onClick: function () { ui.preview(url); } })
              : pend
                ? h("span", { class: "mw-upload__file" }, h("i", { class: "ri-image-line" }), h("span", null, f.name || "照片"))
                : h("a", { class: "mw-upload__file", href: url, target: "_blank" }, h("i", { class: "ri-file-text-line" }), h("span", null, f.name || "文件")),
            pend && h("span", { class: "mw-upload__pending" }, h("i", { class: "ri-upload-cloud-2-line" }), "待上传"),
            !o.disabled &&
              h(
                "button",
                {
                  type: "button",
                  class: "mw-upload__del",
                  "aria-label": "删除",
                  onClick: function () {
                    var n = list.slice();
                    var gone = n.splice(i, 1)[0];
                    list = n;
                    paint();
                    o.onChange && o.onChange(n);
                    if (util.isPendingFile(gone) && !(MW.sync && MW.sync.fileQueued && MW.sync.fileQueued(gone._local))) MW.files.del(gone._local);
                  },
                },
                h("i", { class: "ri-delete-bin-6-line" })
              )
          )
        );
      });
      if (!o.disabled && list.length < max) {
        var file = h("input", {
          type: "file",
          accept: o.accept || null,
          capture: o.capture || null,
          multiple: max - list.length > 1 ? true : null,
          onClick: function (e) {
            if (o.needNet && MW.net.offline) {
              e.preventDefault();
              MW.offline.needNet(o.needNet);
              return;
            }
            MW.sync && MW.sync.holdPick();
          },
          onChange: function (e) {
            var files = [].slice.call(e.target.files || [], 0, max - list.length);
            MW.sync && MW.sync.releasePick();
            if (!files.length) return;
            busy = true;
            MW.uploading = (MW.uploading || 0) + 1;
            paint();
            var stashed = 0;
            /** 没网时把照片暂存在本机（需联网的上传除外），联网后由同步队列补传 */
            function stash(fl) {
              return MW.files.put(fl, fl.name).then(function (id) {
                stashed++;
                return { name: fl.name || "photo.jpg", uid: util.uid(), status: "pending", url: "", _local: id };
              }, function () {
                throw util.netErr("当前网络不可用，且手机无法暂存照片，请联网后再上传");
              });
            }
            Promise.all(
              files.map(function (fl) {
                if (MW.net.offline && !o.needNet) return stash(fl);
                return MW.api.upload(fl).then(function (resp) {
                  var u = resp && resp.FileList && resp.FileList[0] ? resp.FileList[0].url : "";
                  return { name: fl.name, uid: util.uid(), status: "success", url: u, response: resp };
                }, function (err) {
                  if (util.isNetErr(err) && !o.needNet) return stash(fl);
                  throw err;
                });
              })
            )
              .then(function (items) {
                list = list.concat(items).slice(0, max);
                busy = false;
                MW.uploading = Math.max(0, MW.uploading - 1);
                paint();
                o.onChange && o.onChange(list.slice());
                if (stashed) ui.toast("当前网络不可用，" + stashed + " 张照片已暂存在本机，联网后自动上传", "info");
              })
              .catch(function (err) {
                busy = false;
                MW.uploading = Math.max(0, MW.uploading - 1);
                paint();
                if (util.isNetErr(err)) {
                  if (o.needNet) MW.offline.needNet(o.needNet);
                  else ui.toast(util.errMsg(err) || "当前网络不可用，请联网后再上传", "warn");
                } else ui.toast(util.errMsg(err) || "上传失败，请重试", "danger");
              });
          },
        });
        var icon = busy ? "ri-loader-4-line mw-spin" : o.icon || (o.capture ? "ri-camera-3-line" : "ri-image-add-line");
        var hero = o.hero && !list.length;
        wrap.appendChild(
          hero
            ? h(
                "label",
                { class: ["mw-upload__hero", busy && "is-busy"] },
                file,
                h("span", { class: "mw-upload__hero-ico" }, h("i", { class: icon })),
                h(
                  "span",
                  { class: "mw-upload__hero-txt" },
                  h("b", null, busy ? "上传中…" : o.text || "点击拍照"),
                  o.hint && h("small", null, o.hint)
                ),
                !busy && h("i", { class: "ri-arrow-right-s-line mw-upload__hero-go" })
              )
            : h(
                "label",
                { class: ["mw-upload__add", busy && "is-busy"] },
                file,
                h("span", { class: "mw-upload__ico" }, h("i", { class: icon })),
                h("span", null, busy ? "上传中…" : o.text || "上传"),
                max > 1 && h("small", null, list.length + " / " + max)
              )
        );
        if (!hero && o.hint) wrap.appendChild(h("div", { class: "mw-upload__hint" }, h("i", { class: "ri-information-line" }), o.hint));
      } else if (o.disabled && !list.length) {
        wrap.appendChild(h("div", { class: "mw-upload__none" }, h("i", { class: "ri-image-line" }), "暂无"));
      }
    }
    paint();
    return wrap;
  };

  /**
   * 响应式表格：PC 为表格，≤760px 自动转为卡片（同一份 DOM，CSS 切换）
   * o: columns [{title, key, render(row,i), width, required, cls}], rows, empty, rowCls(row,i)
   */
  ui.rtable = function (o) {
    var rows = o.rows || [];
    return h(
      "div",
      { class: ["mw-rtable", o.cls] },
      h(
        "table",
        null,
        h(
          "thead",
          null,
          h(
            "tr",
            null,
            o.columns.map(function (c) {
              return h("th", { style: c.width ? { width: c.width } : null, class: c.cls }, c.required && h("i", { class: "mw-req" }, "*"), c.title);
            })
          )
        ),
        h(
          "tbody",
          null,
          rows.length
            ? rows.map(function (r, i) {
                return h(
                  "tr",
                  { class: o.rowCls ? o.rowCls(r, i) : null },
                  o.columns.map(function (c) {
                    var v = c.render ? c.render(r, i) : r[c.key];
                    return h(
                      "td",
                      { "data-label": c.title || "", class: [c.cls, c.mobileHead && "is-mhead", c.mobileFull && "is-mfull"] },
                      v instanceof Node || Array.isArray(v) ? v : ui.text(v)
                    );
                  })
                );
              })
            : h("tr", { class: "is-empty" }, h("td", { colspan: o.columns.length }, h("div", { class: "mw-empty" }, h("i", { class: "ri-inbox-2-line" }), o.empty || "暂无数据")))
        )
      )
    );
  };

  /* ---------- 按钮 ---------- */
  ui.btn = function (text, o) {
    o = o || {};
    return h(
      "button",
      {
        type: "button",
        class: ["mw-btn", "mw-btn--" + (o.type || "default"), o.block && "mw-btn--block", o.size && "mw-btn--" + o.size, o.loading && "is-loading", o.cls],
        disabled: !!(o.disabled || o.loading),
        title: o.title || null,
        onClick: o.onClick,
      },
      o.loading ? h("i", { class: "ri-loader-4-line mw-spin" }) : o.icon && h("i", { class: o.icon }),
      text && h("span", null, text)
    );
  };

  /* ---------- 反馈 ---------- */
  var toastBox;
  ui.toast = function (msg, type) {
    if (!toastBox) {
      toastBox = MW.addFloating(h("div", { class: "mw-toast-box" }));
      MW.cleanups.push(function () { toastBox = null; });
    }
    var icon = { ok: "ri-checkbox-circle-fill", danger: "ri-close-circle-fill", warn: "ri-error-warning-fill" }[type] || "ri-information-fill";
    var t = h("div", { class: ["mw-toast", "mw-toast--" + (type || "info")] }, h("i", { class: icon }), h("span", null, msg));
    toastBox.appendChild(t);
    setTimeout(function () {
      t.classList.add("is-leave");
      setTimeout(function () {
        t.remove();
      }, 300);
    }, 2400);
  };

  /** 弹窗（PC 居中，手机为底部弹出）。返回 Promise：确定 resolve，取消 reject */
  ui.modal = function (o) {
    return new Promise(function (resolve, reject) {
      var icon = { warning: "ri-error-warning-fill", danger: "ri-close-circle-fill", success: "ri-checkbox-circle-fill" }[o.type] || "ri-information-fill";
      function done(ok) {
        mask.classList.add("is-leave");
        document.body.classList.remove("mw-noscroll");
        setTimeout(function () {
          mask.remove();
          var i = MW.floating.indexOf(mask);
          if (i > -1) MW.floating.splice(i, 1);
        }, 220);
        ok ? resolve() : reject("cancel");
      }
      var content = h("div", { class: "mw-modal__content" });
      if (o.html) content.innerHTML = o.html;
      else if (o.content) content.appendChild(o.content instanceof Node ? o.content : document.createTextNode(o.content));
      var mask = h(
        "div",
        { class: "mw-mask", onClick: function (e) { if (e.target === mask && o.maskClose !== false) done(false); } },
        h(
          "div",
          { class: ["mw-modal", o.type && "mw-modal--" + o.type, o.wide && "mw-modal--wide"], role: "dialog" },
          h("div", { class: "mw-modal__grab" }),
          h("div", { class: "mw-modal__head" }, h("i", { class: icon }), h("b", null, o.title || "提示"),
            h("button", { type: "button", class: "mw-modal__x", onClick: function () { done(false); } }, h("i", { class: "ri-close-line" }))),
          content,
          h(
            "div",
            { class: "mw-modal__foot" },
            o.showCancel !== false && ui.btn(o.cancelText || "取消", { onClick: function () { done(false); } }),
            ui.btn(o.okText || "确定", { type: o.type === "danger" ? "danger" : "primary", onClick: function () { done(true); } })
          )
        )
      );
      MW.addFloating(mask);
      document.body.classList.add("mw-noscroll");
    });
  };
  ui.alert = function (html, o) {
    return ui.modal(Object.assign({ html: html, showCancel: false, type: "warning" }, o || {}));
  };
  ui.confirm = function (html, o) {
    return ui.modal(Object.assign({ html: html, type: "warning" }, o || {}));
  };

  /** 全局 loading（对应 $form.setLoading） */
  var loadingEl, loadingTimer;
  ui.loading = function (ms, text) {
    if (!loadingEl) {
      loadingEl = MW.addFloating(h("div", { class: "mw-loading" }, h("div", { class: "mw-loading__box" }, h("i", { class: "ri-loader-4-line mw-spin" }), h("span", null, ""))));
      MW.cleanups.push(function () { loadingEl = null; clearTimeout(loadingTimer); });
    }
    loadingEl.querySelector("span").textContent = text || "处理中…";
    loadingEl.classList.add("is-show");
    clearTimeout(loadingTimer);
    loadingTimer = setTimeout(function () {
      loadingEl.classList.remove("is-show");
    }, ms || 2000);
  };

  ui.preview = function (url) {
    var m = MW.addFloating(h("div", { class: "mw-lightbox", onClick: function () { m.remove(); } }, h("img", { src: url }), h("i", { class: "ri-close-line" })));
  };

  /** 滚动到首个错误字段 */
  ui.scrollToError = function () {
    setTimeout(function () {
      var el = MW.$(".has-error");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 60);
  };
}
